<ndt-add-provider-call-costs-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-add-provider-call-costs-view>
